<template>
    <div class="taxo-setup container-fluid">
        <CRow class="pr-2">
    <CCol col="10" xl="10" class="p-0">
      <CCard >
        <CCardBody>

   <a-card class="edit-card"  style="margin:0; padding:0;"  :body-style="{padding:0}">
                          <span slot="title"><h6 class="w-100 mb-0 text-muted">SEO</h6>Nastavenia</span>
                            <span slot="extra">

                  </span>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :rowKey="record => record.id"
                                    :pagination="pagination"
                                    :dataSource="data"
                                    :loading="loading"
                                    class="table-flush">


                                <template slot="editable" slot-scope="text, record">
                                   <div class="editable-cell">
                                    <template v-if="record.globalseotitle && !text"><span class="seo-text-muted">{{ record.globalseotitle }}</span></template>
                                        <div v-if="editable === 'seotitle' + record.id" class="editable-cell-input-wrapper">
                                          <template v-if="record.bundle != 'taxonomy'">
                                          <a-input :value="text" @change="(e) => handleChange(e,record.id,'seotitle')" @pressEnter="check(record.id,'seotitle')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="check(record.id,'seotitle')"
                                        />
                                      </template>
                                      <template v-else>
                                        <a-input :value="text" @change="(e) => handleChange(e,record.id,'seotitle')" @pressEnter="checkTaxonomy(record.id,'seotitle')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="checkTaxonomy(record.id,'seotitle')"
                                        />
                                      </template>
                                        </div>
                                        <div v-else class="editable-cell-text-wrapper">
                                            {{ text || ' ' }}
                                            <a-icon type="edit" class="editable-cell-icon" @click="edit(record.id,'seotitle')" />
                                        </div>
                                    </div>
                                </template>
                                <template slot="editableUrl" slot-scope="text, record">
                                     <div class="editable-cell">
                                        <div v-if="editable === 'url' + record.id" class="editable-cell-input-wrapper">
                                             <template v-if="record.bundle != 'taxonomy'">
                                          <a-input :value="text" @change="(e) => handleChange(e,record.id,'url')" @pressEnter="check(record.id,'url')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="check(record.id,'url')"
                                        />
                                      </template>
                                      <template v-else>
                                        <a-input :value="text" @change="(e) => handleChange(e,record.id,'url')" @pressEnter="checkTaxonomy(record.id,'url')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="checkTaxonomy(record.id,'url')"
                                        />
                                      </template>
                                        </div>
                                        <div v-else class="editable-cell-text-wrapper">
                                            {{ text || ' ' }}
                                            <a-icon type="edit" class="editable-cell-icon"  @click="edit(record.id,'url')" />
                                        </div>
                                    </div>
                                </template>
                                <template slot="editableDescription" slot-scope="text, record">
                                    <div class="editable-cell">
                                        <template v-if="record.globalseodescription && !text"><span class="seo-text-muted">{{ record.globalseodescription }}</span></template>
                                        <div v-if="editable === 'seodescription' + record.id" class="editable-cell-input-wrapper">
                                          <template v-if="record.bundle != 'taxonomy'">
                                          <a-input :value="text" @change="(e) => handleChange(e,record.id,'seodescription')" @pressEnter="check(record.id,'seodescription')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="check(record.id,'seodescription')"
                                        />
                                      </template>
                                      <template v-else>
                                        <a-input :value="text" @change="(e) => handleChange(e,record.id,'seodescription')" @pressEnter="checkTaxonomy(record.id,'seodescription')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="checkTaxonomy(record.id,'seodescription')"
                                        />
                                      </template>
                                        </div>
                                         <div v-else class="editable-cell-text-wrapper">
                                            {{ text || ' ' }}
                                            <a-icon type="edit"  class="editable-cell-icon" @click="edit(record.id,'seodescription')" />
                                        </div>
                                    </div>
                                </template>
                                <template slot="url" slot-scope="title,record">
                                    <a v-if="record.url" :href="vars.site_url + '/' + record.language + '/' + record.url" target="_blank" style="color:#3c3c3c" class=""><span v-if="title">{{title}}</span><span v-else><i class="fal fa-times"></i></span></a>
                                    <span v-else><span v-if="title">{{title}}</span><span v-else><i class="fal fa-times"></i></span></span>
                                </template>
                                <template slot="editableKeywords" slot-scope="text,record">
                                    <div class="editable-cell">
                                       <template v-if="editable === 'seokeywords' + record.id">
                                        <div class="editable-cell-input-wrapper">

                                        <template v-if="record.bundle != 'taxonomy'">
                                          <a-input :value="text" @change="(e) => handleChange(e,record.id,'seokeywords')" @pressEnter="check(record.id,'seokeywords')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="check(record.id,'seokeywords')"
                                        />
                                      </template>
                                      <template v-else>
                                        <a-input :value="text" @change="(e) => handleChange(e,record.id,'seokeywords')" @pressEnter="checkTaxonomy(record.id,'seokeywords')" /><a-icon
                                                type="check"
                                                class="editable-cell-icon-check"
                                                @click="checkTaxonomy(record.id,'seokeywords')"
                                        />
                                      </template>


                                        </div></template>
                                        <div v-else class="editable-cell-text-wrapper">
                                            {{ text || ' ' }}
                                            <a-icon type="edit" class="editable-cell-icon" @click="edit(record.id,'seokeywords')" />
                                        </div>
                                    </div>
                                </template>


                                <template slot="date" slot-scope="detailed">
                                    {{formatDateN(detailed)}}
                                </template>
                                <template slot="trans" slot-scope="translations,record">
                                    <div class="trans" :key="lang + record.entity_id" v-for="(trans,lang) in translations">
                                        <router-link :to="record.bundle != 'taxonomy' ? '/edit-content/'  + trans.entity_id : '/edit-taxonomy-item/'  + trans.entity_id + '/' + trans.voc" v-if="trans.lang" class="translation-button m-1" :href="record.bundle != 'taxonomy' ? '/edit-content/' : '/edit-taxonomy-item/' + trans.entity_id">
                                            <base-button type="secondary" size="sm" :title="trans.value"  class="add-button edit-button"  icon="fal fa-check">{{lang}}</base-button>
                                        </router-link>
                                        <base-button v-else type="primary" size="sm"  class="translation-button m-1" @click="handleSubmit(record.entity_id,lang)" icon="far fa-plus">{{lang}}</base-button>
                                    </div>
                                </template>
                                <template slot="name" slot-scope="user,record">
                                    <router-link :to="record.bundle != 'taxonomy' ? '/edit-content/'  + user.id : '/edit-taxonomy-item/' + user.id + '/' + user.voc" class="btn text-default btn-icon btn-secondary btn-sm" ><span class="btn-inner--icon" style="margin-right:5px"><i class="fad fa-pencil-alt"></i></span>Upraviť</router-link>
                                </template>
                            </a-table>
                        </div>
                    </div>
                    <div class="quick-links" v-if="contenttypes">
                        <div class="card-footer pb-5" style="display:inline-block;width:100%;">
                            <label style="float:left;display:inline;margin-right:20px;" class="text-muted">Rýchle odkazy preklady: </label>
                            <span :key="carr.id" v-for="carr in contenttypes" >
                                <template v-if="checkifHasSeo(carr)">
                           <router-link :to="'/seo/' + carr.slug"  class="m-1 float-left"  :href="'/seo/' + carr.slug">
                                <base-button type="outline-primary" :class="'extramuted text-muted' + (carr.slug === slug  ? ' selected' : '')" size="sm">{{carr.title}}</base-button>
                        </router-link>
                    </template>
                    </span>
                   </div>
                  </div>
                </div>
            </div>
        </div>
        </a-card>
        </CCardBody>
        </CCard>
        </CCol>
        </CRow>

    </div>
</template>
<script>
    import {dataService} from "../_services";
    import moment from 'moment'

    import FormItem from 'ant-design-vue'
    import Vue from "vue"

    Vue.use(FormItem);

    const columns = [
        {
            title: 'Názov',
            label: 'Názov',
            field: 'title',
            width: '15%',
            dataIndex: 'title',
            scopedSlots: {customRender: 'url'},
        },
        {
            title: 'URL',
            dataIndex: 'url',
            label: 'URL',
            width: '10%',
            field: 'url',
            scopedSlots: { customRender: 'editableUrl' },
        },
        {
            title: 'Jazyk',
            label: 'Jazyk',
            field: 'language',
            dataIndex: 'language',
        },
        {
            title: 'Seo title',
            dataIndex: 'seotitle',
            label: 'SEO title',
            field: 'seotitle',
            width: '20%',
            alternative: 'globalseotitle',
            scopedSlots: { customRender: 'editable' },
        },
        {
            title: 'Seo description',
            dataIndex: 'seodescription',
            label: 'SEO seodescription',
            field: 'seodescription',
            width: '20%',
            alternative: 'globalseodescription',
            scopedSlots: { customRender: 'editableDescription'}
        },
        {
            title: 'Seo keywords',
            dataIndex: 'seokeywords',
            label: 'SEO seokeywords',
            width: '20%',
            field: 'seokeywords',
            scopedSlots: { customRender: 'editableKeywords'}
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        }
    ];

    var locale = {
        "lang": {
            "placeholder": "Vybrať dátum",
            "rangePlaceholder": ["Termín od", "do"],
            "today": "Dnes",
            "now": "Teraz",
            "backToToday": "Späť na dnes",
            "ok": "Ok",
            "clear": "Vymazať",
            "month": "Mesiac",
            "year": "Rok",
            "timeSelect": "Vybrať čas",
            "dateSelect": "Vybrať dátum",
            "monthSelect": "Vybrať mesiac",
            "yearSelect": "Vybrať rok",
            "decadeSelect": "Vybrať dekádu",
            "yearFormat": "YYYY",
            "dateFormat": "M/D/YYYY",
            "dayFormat": "D",
            "dateTimeFormat": "M/D/YYYY HH:mm:ss",
            "monthFormat": "MMMM",
            "monthBeforeYear": true,
            "previousMonth": "Predchádzajúci mesiac (PageUp)",
            "nextMonth": "Nasledujúci mesiac (PageDown)",
            "previousYear": "Minulý rok (Control + left)",
            "nextYear": "Nasledujúci rok (Control + right)",
            "previousDecade": "Minulá dekáda",
            "nextDecade": "Nasledujúca dekáda",
            "previousCentury": "Minulé storočie",
            "nextCentury": "Nasledujúce storoťie"
        },
        "timePickerLocale": {
            "placeholder": "Vybrať čas"
        },
        "dateFormat": "DD.MM.YYYY",
        "dateTimeFormat": "DD.MM.YYYY HH:mm:ss",
        "weekFormat": "YYYY-wo",
        "monthFormat": "YYYY-MM"
    }

    export default {
        name: "translations",
        props: ["slug"],
        components: {},
        data() {
            return {
                data: [],
                campaignModal: false,
                loading: false,
                editable:false,
                vars:{},
                value:"",
                pagination: {
                    hideOnSinglePage: false,
                    pageSize: 300, // default number of pages per page
                    showSizeChanger: true, // display can change the number of pages per page
                    pageSizeOptions: ['10', '20', '30', '40','100','300','1000'], // number of pages per option
                    showTotal: total => `Položiek: ${total}`, // show total
                    showSizeChange: (current, pageSize) => {  this.pageSize = pageSize; }, // update display when changing the number of pages per page
                },
                locale,
                types:[{"value":1,"label": "Objednávka"},{"value":2,"label": "Produkt"}],
                contenttype: "Web",
                contenttypes:[],
                campaign: {'title':'','image':''},
                colorsto: JSON.parse(localStorage.colors),
                columns,
            };
        },
        mounted() {
            this.fetch();
            dataService.axiosFetch("variable/site_url").then(results => {
                    this.vars = results;
                })
            dataService.axiosFetch("seotypes").then(results => {

                let pa = this;
                results.forEach(obj => {

                    if(obj.slug === pa.slug)
                        pa.contenttype = obj.title;
                });

                this.contenttypes = results;
            });

        },
        methods: {
            checkifHasSeo(cttype)
            {
                return cttype.allfields.find(item => item.slug === 'seodescription');
            },
            confirm(e) {
                dataService.axiosDelete('seo', e).then(results => {
                    if (results) {
                        this.data.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            exportSeo()
            {
    dataService.axiosPost('export/seo/xls',values).then(results => {
                    console.log(results);
    let byte = results.data[0];

    console.log(byte);
    var reportName = 'export.xml';
                    var blob = new Blob([byte], {type: "application/xml"});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();

     });
    },
            handleChange(e,id,dataIndex) {
                const value = e.target.value;
                this.value = value;
                const dataSource = [...this.data];
                const target = dataSource.find(item => item.id === id);
                if (target) {
                    target[dataIndex] = value;
                    this.dataSource = dataSource;


                }
            },
            check(id,dataIndex) {
                this.editable = false;

                dataService.axiosPost("seoupdate", {"value" : this.value,"nid":id,"field":dataIndex});


            },
            checkTaxonomy(id,dataIndex) {
                this.editable = false;
                dataService.axiosPost("seoupdate", {"value" : this.value,"bundle":"taxonomy","nid":id,"field":dataIndex});


            },
            edit(e,dataIndex) {

this.editable = dataIndex + e;
},
editTaxonomy(e,dataIndex) {
this.editable = dataIndex + e;
},
            onCellChange(key, dataIndex, value) {
                const dataSource = [...this.dataSource];
                const target = dataSource.find(item => item.key === key);
                if (target) {
                    target[dataIndex] = value;
                    this.dataSource = dataSource;
                }
            },
            addCampaign()
            {
                dataService.axiosPost("adddocument", this.campaign).then(() => {
                    this.fetch();
                });
                //  this.campaignModal = false;
            },
            onChildChange(value) {
                this.campaign.image = JSON.stringify(value);
            },
            openCampaignModal() {
                this.campaignModal = true;
            },
            cancel() {
            },
            formatDateN: function(dt){

                return moment(dt,'YYYY-MM-DD').format('D.M.YYYY')


            },
            getSEOdata()
            {
                let fill = [];
                dataService.axiosFetch('seo',this.slug).then(results => {
                   fill = results;
                });
                return fill;
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch('seo',this.slug).then(results => {
                    this.data = results;
                    this.loading = false;
                });
            }

        },
    };
</script>

<style>
    .image-editor .image-uploader,
    .image-editor .image-property
    {width:49%!important;}
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }
    .translation-button
    {float:left;}
    .ant-pagination a {
        color: #1890ff;
        text-decoration: none;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
        -webkit-text-decoration-skip: objects;
    }

    .ant-pagination a:focus {
        text-decoration: underline;
        -webkit-text-decoration-skip: ink;
        text-decoration-skip-ink: auto;
    }

    .ant-pagination a:hover {
        color: #40a9ff;
    }

    .ant-pagination a:active {
        color: #096dd9;
    }

    .ant-pagination a:active, a:hover {
        text-decoration: none;
        outline: 0;
    }
.seo-text-muted
{color:#ccc;}
    .ant-pagination a {
        -ms-touch-action: manipulation;
        touch-action: manipulation;
    }

    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination-item a, .ant-pagination-prev a, .ant-pagination-next a, .ant-pagination-jump-prev a, .ant-pagination-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination-item a, .ant-pagination-prev a, .ant-pagination-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: .875rem;
    }

    .ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link {
        width: 36px;
        height: 36px;
        padding: 0;
        margin: 0 3px;
        font-size: 12px;
    }

    .ant-pagination-item.ant-pagination-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination-item-link.ant-pagination-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
